import {
    ActionCreatorWithPayload,
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatChannelPartedEvent,
    NinchatEventType,
} from '../types/events'
import {
    NinchatClientPromiseValue,
    NinchatEventActionPayload,
} from '../NinchatClient'
import {RootState} from '../../store'
import {extractProperties} from '.'
import {replace} from '../../navigation/actions'
import router from '../../navigation/router'

const eventTypePrefix = 'NINCHAT/event'

type ChannelPartedAsyncThunk = typeof thunk & {reducer: CaseReducer} & ChannelPartedActionCreator

type ChannelPartedActionCreator = ActionCreatorWithPayload<NinchatEventActionPayload<NinchatChannelPartedEvent>, 'NINCHAT/event/channel_parted'>

type ChannelPartedAsyncThunkConfig = {
    state: RootState
}

const thunk = createAsyncThunk<NinchatClientPromiseValue, NinchatChannelPartedEvent, ChannelPartedAsyncThunkConfig>(
    `${eventTypePrefix}/${NinchatEventType.NinchatChannelPartedEvent}`,
    (event, thunkAPI) => {
        const {channel_id} = event

        const {
            position,
            routes,
        } = thunkAPI.getState().navigation

        const route = routes[position]

        if (router.isRoute<'Channel'>('Channel', route) && route.params.channel_id === channel_id) {
            thunkAPI.dispatch(replace({name: 'Home'}))
        }

        return event
    },
)

export const channelParted = thunk as ChannelPartedAsyncThunk

channelParted.reducer = (state, action) => {
    const {channel_id} = extractProperties<NinchatChannelPartedEvent>(action.payload)

    delete state.user_channels[channel_id]
}
